import { gql } from '@apollo/client';

import ADDRESS_FRAGMENT from '../fragments/address';
import GENERAL_FIELDS_FRAGMENT from '../fragments/general';
import META_FRAGMENT from '../fragments/meta';

export const findOneInvoiceEntity = gql`
  query findOneInvoiceEntity($id: String, $hasBalance: Boolean) {
    findOneInvoiceEntity(id: $id, hasBalance: $hasBalance) {
      id
      invoiceId
      paid
      total
      balance
      createdAt
      type
      payments {
        id
        method
        reference
        createdAt
        amount
        updatedAt
      }
      invoiceDetails {
        id
        createdAt
        fee
        appointment {
          id
          transaction {
            id
            signatories
          }
          date
          type
          clientInPersonFee
          clientRONFee
          notaryGetInPerson
          notaryGetRON
          notary {
            firstName
            lastName
          }
          signatoryIds
        }
      }
      transaction {
        id
      }
    }
  }
`;

export const findInvoiceEntity = gql`
  ${META_FRAGMENT}
  query findInvoiceEntity($target: String, $hasBalance: Boolean, $order: InvoiceSortFields) {
    findInvoiceEntity(target: $target, hasBalance: $hasBalance, order: $order) {
      data {
        id
        invoiceId
        paid
        total
        balance
        createdAt
        type
        payments {
          id
          method
          reference
          createdAt
          amount
        }
        invoiceDetails {
          id
          createdAt
          fee
          appointment {
            id
            transaction {
              id
              signatories
            }
            date
            type
            clientInPersonFee
            clientRONFee
            notaryGetInPerson
            notaryGetRON
            notary {
              firstName
              lastName
            }
            signatoryIds
          }
        }
        transaction {
          id
        }
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const GET_INVOICES = gql`
  ${META_FRAGMENT}
  query getInvoices($target: String) {
    findInvoiceEntity(target: $target) {
      data {
        id
        invoiceId
        paid
        total
        balance
        createdAt
        type
        payments {
          id
          method
          reference
          createdAt
          amount
        }
        invoiceDetails {
          id
          createdAt
          fee
          appointment {
            id
            transaction {
              id
              signatories
            }
            date
            type
            clientInPersonFee
            clientRONFee
            notaryGetInPerson
            notaryGetRON
            notary {
              firstName
              lastName
            }
            signatoryIds
          }
        }
        transaction {
          id
        }
        notary {
          firstName
          lastName
          id
        }
        company {
          name
          id
        }
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const GET_COMPANY_WITH_NOTARY = gql`
  ${GENERAL_FIELDS_FRAGMENT}
  ${ADDRESS_FRAGMENT}
  query getNotaryAndCompanyForInvoice($target: String) {
    findOneUserEntity(id: $target) {
      ...GeneralFieldsFragment
      ...AddressFragment
      appointmentCount
      # total
      # balance
      # paid
    }
    findOneCompanyEntity(id: $target) {
      id
      name
      address
      appointmentCount
      # total
      # paid
      # balance
      avatar {
        id
        thumbnailPipeFrom
        pipeFrom
      }
    }
  }
`;
